<template lang="pug">
  .product-list(:class="[small && 'small', !small && reactive && 'reactive']")
    h3(v-if="title") {{ __(title, 'auto') }}
    Carousel.featured-products(
      :theme="'mobile-overflow '+ (small ? 'small-pad' : '')"
      :controls="!small"
      :arrowOffset="arrowOffset"
      :label="title || 'Products'"
      :prevLabel="title ? `Previous ${title}` : 'Previous products'"
      :nextLabel="title ? `Next ${title}` : 'Next products'"
    )
      ProductList(
        :widget="widget"
        :podId="podId"
        :itemIds="itemIds"
        :filterGroupIds="filterGroupIds"
        :groupId="groupId"
        :size="size"
        :category="(products != null) ? null : category"
        :small="small"
        :lazy="lazy || !!products"
        :filter="filter"
        :products="products"
        :displayHotDeals="displayHotDeals"
      )
        template(#product="data")
          slot(name="product" :product="data.product")
</template>
<script setup lang="ts">
import type { CatalogFilter, CatalogProduct } from '../../js/sisuTypes'
import ProductList from './ProductList.vue'

withDefaults(defineProps<{
  title?: string | null,
  // Reflektion widget, also used for tracking (will default to For You)
  widget?: string,
  // Constructor.io recommendation pod ID
  podId?: string,
  // Constructor.io item IDs for item-aware recommendations
  itemIds?: string[],
  // Constructor.io filter group IDs (for recommendations)
  filterGroupIds?: string[],
  // Constructor.io browse group ID (for browse results)
  groupId?: string,
  // Category for RFK to load. Also used for tracking if passing products directly
  category?: string,
  // Reflektion filter
  filter?: CatalogFilter,
  // Instead of passing Category / Widget, we can pass products directly
  products?: CatalogProduct[],
  size?: string | null,
  displayHotDeals?: boolean,
  small?: boolean,
  // Resize to 250x250 on mobile
  reactive?: boolean,
  // Only load when visible
  lazy?: boolean,
  arrowOffset?: string,
}>(), {
  title           : null,
  size            : null,
  displayHotDeals : false,
  small           : false,
  reactive        : true,
  lazy            : false,
  arrowOffset     : '100px',
})
</script>
